.subcriptionsPage {
	div.searchWrapper {
		@apply yst-max-w-xl;
		clear: both;
	}

	p.headerText {
		max-width: 600px;
		margin-top: 1em;
	}

	.shopButton {
		margin: 3em 0 0;
	}

	.suggestedActionContainer {
		display: flex;
		justify-content: center;
		align-items:center;
	}
}

// The table emits its own trailing `<br />`, which is where the gap between sections comes from — the same
// rhythm the stacked sections had before. Only the first section needs a nudge away from the search box.
.subscriptionsSection {
	@apply first:yst-mt-6;
}

// Sized in ems so the pill tracks whatever the heading's font size is, rather than drifting out of
// proportion the next time that changes.
.sectionCount {
	@apply yst-ml-2 yst-inline-block yst-rounded-full yst-bg-slate-100 yst-font-normal yst-text-slate-600;

	font-size: 0.7em;
	padding: 0.15em 0.6em;
	vertical-align: 0.15em;
}


.paginationFooter {
	@apply yst-flex yst-flex-wrap yst-items-center yst-justify-end yst-gap-x-4 yst-gap-y-2 yst-mt-4;
}

.showingResults {
	@apply yst-text-sm yst-text-slate-600;
}
